<template>
  <div v-if="rowID !== '0'">
    <div v-if="loading" style="min-height: 200px" class="d-flex flex-row align-center">
      <v-progress-linear indeterminate></v-progress-linear>
    </div>
    <div class="blocks" v-else>
      <div
        class="blocks__headerDiv"
        style="display: flex; flex-direction: row"
        :style="!blockOpened ? 'border-bottom: none' : ''"
        @click="blockOpened = !blockOpened">
        <p class="headerText">
          Блок 4. Проведение научно-исследовательских и опытно-конструкторских работ, внедрение
          результатов научно-исследовательских и опытно- конструкторских работ
        </p>
        <img
          v-if="blockOpened"
          src="@/assets/icons/block_opened_blue.svg"
          class="btn_open"
          alt="" />
        <img v-else src="@/assets/icons/block_closed_blue.svg" class="btn_open" alt="" />
      </div>
      <div v-if="blockOpened && block4Data.length > 0">
        <Block4Item
          v-for="(item, j) in block4Data"
          :key="j"
          :value.sync="item"
          :rowID="rowID"
          :konvertConvert="konvertConvert"
          :order="j"
          :applicantBlocked="applicantBlocked"
          :patentTypeArray="patentTypeArray"
          @updateData="getAllBlock4" />
      </div>
      <Block4Creation
        v-if="blockOpened && blockEditingInProcess && !applicantBlocked"
        :applicantBlocked="applicantBlocked"
        :rowID="rowID"
        @updateData="getAllBlock4" />
      <div class="btnDiv" v-if="blockOpened && block4Data.length > 0">
        <button v-if="applicantBlocked || isExpert" class="usual-btn usual-btn_disabled">
          Добавить
        </button>
        <button v-else class="usual-btn" @click="addRow">Добавить</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  import Block4Item from '@/components/applicants/applicantForm/valievBlocks/blockItems/Block4Item';
  import Block4Creation from '@/components/applicants/applicantForm/valievBlocks/blockCreation/Block4Creation';

  export default {
    name: 'Block4',
    components: { Block4Creation, Block4Item },
    data() {
      return {
        loading: false,
        blockOpened: false,
        blockEditingInProcess: true,
        block4Data: [],
        patentTypeArray: [],
      };
    },
    props: {
      rowID: {
        type: String,
        default: '',
      },
      applicantBlocked: {
        type: Boolean,
        default: false,
      },
      konvertConvert: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters('keycloak', {
        getAuthData: 'getAuthData',
        isExpert: 'isExpert',
        // isCurator: 'isCurator',
      }),
    },
    created() {
      if (this.rowID !== '0') {
        this.getAllBlock4();
        this.getSprPatentType();
      }

      if (this.isExpert) {
        this.blockOpened = true;
      }
    },
    methods: {
      async getAllBlock4() {
        this.loading = true;
        this.block4Data = [];
        try {
          const res = await axios.get(`/api/2022/valiev/block4/get?mainId=${this.rowID}`, {
            headers: { Authorization: `Bearer   ${this.getAuthData.token}` },
          });
          if (res.status === 200 && res.data) {
            if (res.data.length > 0) {
              this.block4Data = res.data;
              this.blockEditingInProcess = false;
            } else {
              this.blockEditingInProcess = true;
            }
            console.log('getAllBlock4 успех');
            this.loading = false;
          }
        } catch (e) {
          this.loading = false;
          console.log(e);
        }
      },
      async getSprPatentType() {
        try {
          const res = await axios.get(`/api/2022/spr/textValKorolev/get?block=44&position=1`, {
            headers: { Authorization: `Bearer   ${this.getAuthData.token}` },
          });
          if (res.status === 200 && res.data) {
            for (let i = 0; i < res.data.length; i++) {
              this.patentTypeArray.push({
                text: res.data[i].value,
                value: res.data[i].id,
              });
            }
            console.log('getSprPatentType успех');
          }
        } catch (e) {
          console.log(e);
        }
      },

      addRow() {
        this.blockEditingInProcess = true;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
